<nav ngbDropdown class="custom-dropdown">
  <button class="dots" id="dropdownConfig" ngbDropdownToggle (click)="($event)">
    <img src="assets/images/icons/three-dots-vertical.svg " alt="options " />
  </button>
  <nav ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownConfig">
    <a (click)="redirectVisualizar()" ngbDropdownItem>Visualizar</a>
    <a (click)="redirectAtualizar()" ngbDropdownItem>Atualizar</a>
    <app-modal-deletar
      [dado]="dados.titulo"
      (deleteRequest)="deletar()"
    ></app-modal-deletar>
  </nav>
</nav>

